__turbopack_context__.v({
  "menuContent": "userProfileMenu-module-scss-module__PJPacW__menuContent",
  "menuWrapper": "userProfileMenu-module-scss-module__PJPacW__menuWrapper",
});
